import { useRouter } from 'next/router';
import { Button } from '~/components/common/button';
import Modal from '~/components/common/modal';
import { Section } from '~/components/common/section';
import { Translate, useTranslate } from '~/i18n';
import { CloseIcon } from '~/svgs';

const GoToBankInfoModal = ({ open, setOpen }: any) => {
   const router = useRouter();
   const { lang } = useTranslate();

   return (
      <Modal size="sm" open={open}>
         <Modal.Body>
            <Section className="p-2 ">
               <div className="w-full flex justify-end">
                  <button className=" mx-6 mt-3" onClick={() => setOpen(false)}>
                     <CloseIcon />
                  </button>
               </div>
               <div className="flex flex-col items-center my-5 px-5 text-center ">
                  <div className="font-bold text-3xl mb-2">
                     <Translate id="payout:add your banking details" />
                  </div>
                  <div className="font-normal text-base text-[#595959] mx-14 mb-8 ">
                     <Translate id="payout:to proceed with payout, please enter your banking details first." />
                  </div>
                  <div className="flex justify-between w-full">
                     <Button
                        className="!w-52 h-12 "
                        onClick={() => setOpen(false)}
                        size={100}
                        theme="secondary">
                        <span className="text-lg font-semibold  ">
                           <Translate id="payout:cancel" />
                        </span>
                     </Button>
                     <Button
                        onClick={() => {
                           router.push(`/${lang}/orders/bank-details`);
                           setOpen(false);
                        }}
                        className="h-[48] rounded-2xl"
                        theme="primary">
                        <span className="text-lg font-semibold ">
                           <Translate id="payout:go to banking details" />
                        </span>
                     </Button>
                  </div>
               </div>
            </Section>
         </Modal.Body>
      </Modal>
   );
};

export default GoToBankInfoModal;
